import React, { useEffect, useState } from 'react';
import './SalaryCalculatorButton.css'; // Import the CSS file

const SalaryCalculatorButton = () => {
  const [label, setLabel] = useState('$alary Calculator');

  useEffect(() => {
    const updateButtonLabel = () => {
      if (window.innerWidth <= 768) {
        setLabel('$alary');
      } else {
        setLabel('$alary Calculator');
      }
    };

    updateButtonLabel();
    window.addEventListener('resize', updateButtonLabel);

    return () => window.removeEventListener('resize', updateButtonLabel);
  }, []);

  return (
    <a
      href="https://accountantsonair.com/salary-calculator"
      className="salary-calculator-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
};

export default SalaryCalculatorButton;
